export default __webpack_public_path__ + "static/media/banner.20bdd2cf.jpeg";